import React from "react";
import CrudTable from "../components/CrudTable";
import { formatINR } from "../lib/api";

const columns = [
  { key: "name", label: "Pool" },
  { key: "total_capital", label: "Capital", render: (v) => formatINR(v || 0) },
  { key: "number_of_assets", label: "Assets" },
  { key: "current_value", label: "Value", render: (v) => formatINR(v || 0) },
  { key: "total_revenue", label: "Revenue", render: (v) => formatINR(v || 0) },
  { key: "expected_yield_percent", label: "Yield %" },
];
const formFields = [
  { name: "name", label: "Pool Name", required: true },
  { name: "total_capital", label: "Total Capital (₹)", type: "number", default: 0 },
  { name: "current_value", label: "Current Value (₹)", type: "number", default: 0 },
  { name: "total_revenue", label: "Total Revenue (₹)", type: "number", default: 0 },
  { name: "expected_yield_percent", label: "Expected Yield (%)", type: "number", default: 12 },
];

export default function AssetPools() {
  return <CrudTable title="Asset Pools"
    description="Group assets into investment pools with dedicated analytics."
    endpoint="/asset-pools" columns={columns} formFields={formFields} />;
}
